const filterOptions = document.getElementsByClassName('filterOption')
const filterCatTitle = document.getElementsByClassName('filterCategoryTitle')
const activeFilters = []
const filterByCat = []
const filterCat = document.querySelectorAll('ul[data-master-cat]')
let activeSort = 'none'
const sortBy = document.getElementById('sortBy')
const url = window.location.href
const org = window.location.origin
const mobileFilter = document.getElementById('mobileFilterContainer')
const filterBy = document.getElementById('filterByContainer')
const qryCalls = []

const multiOpt = [
  {
    name: 'exotic',
    filters: ['kangaroo', 'quail', 'guineafowl']
  },
  {
    name: 'zoo',
    filters: ['monkey', 'marmoset', 'tamarin', 'primate']
  },
  {
    name: 'treat',
    filters: ['chews', 'biscuits', 'training', 'jerky', 'dental']
  },
  {
    name: 'bird',
    filters: ['parakeet', 'finch', 'cockatiel', 'parrots', 'conure', 'grey', 'macaws', 'bird']
  },
  {
    name: 'bird-x-small',
    filters: ['parakeet', 'finch']
  },
  {
    name: 'bird-small',
    filters: ['cockatiel']
  },
  {
    name: 'bird-medium',
    filters: ['parrots', 'conure']
  },
  {
    name: 'bird-large',
    filters: ['grey', 'macaws']
  },
  {
    name: 'grain-free',
    filters: ['grain-free', 'grain free']
  },
  {
    name: 'limited',
    filters: ['limited', 'limited ingredients']
  },
  {
    name: 'freeze-dried',
    filters: ['freeze-dried', 'freeze dried']
  },
  {
    name: 'bowl',
    filters: ['feeder']
  },
  {
    name: 'collar',
    filters: ['collar', 'leash']
  },
  {
    name: 'vitamin',
    filters: ['multivitamin', 'vitamin blend']
  },
  {
    name: 'cleaning',
    filters: ['clean', 'carpet cleaner', 'cleaning supplies']
  },
  {
    name: 'flea',
    filters: ['tick', 'flea and tick']
  },
  {
    name: 'small pet',
    filters: ['small animal', 'rabbit', 'guniea pig', 'hamster', 'ferret']
  },
  {
    name: 'livestock',
    filters: ['cow', 'sheep', 'goat', 'cattle', 'calf', 'duck', 'hens', 'poultry', 'fowl', 'pig']
  },
  {
    name: 'horse',
    filters: ['equine']
  },
  {
    name: 'supplies',
    filters: ['bowl', 'feeder', 'collar', 'leash', 'tick', 'flea and tick', 'toy', 'clean', 'cleaning']
  }
]


const urlParams = new URLSearchParams(window.location.search);
urlParams ? myParam = urlParams.get('filter') : null
Array.from(filterCat).forEach(item => filterByCat.push([]))

Array.from(filterCatTitle).forEach(item => item.addEventListener('click', (event) => titleShow(event)))


function titleShow(event) {
  let dataNum = event.target.getAttribute('data-master-cat')
  let ul = document.querySelector(`.filterCategoryOptions[data-master-cat='${dataNum}']`)
  let chev = document.querySelector(`i[data-master-cat='${dataNum}']`)
  ul.classList.toggle('showCategoryOptions')
  chev.classList.toggle('chevron-down')
  chev.classList.toggle('chevron-up')
}

sortBy.addEventListener('change', (event) => {
  const str = `${event.target.value}`
  // console.log(str)
  switch (str) {
    case 'featured':
      activeSort = `sort_by=manual`
      break;
    case 'relevance':
      activeSort = `sort_by=relevance`
      break;
    case 'best':
      activeSort = `sort_by=best-selling`
      break;
    case 'aToZ':
      activeSort = `sort_by=title-ascending`
      break;
    case 'zToA':
      activeSort = `sort_by=title-descending`
      break;
    case 'lowToHigh':
      activeSort = `sort_by=price-ascending`
      break;
    case 'highToLow':
      activeSort = `sort_by=price-descending`
      break;
    case 'oldToNew':
      activeSort = `sort_by=created-ascending`
      break;
    case 'newToOld':
      activeSort = `sort_by=created-descending`
      break;
    default:
      activeSort = 'none'
      break;
  }
  let v = filterOptionChange()
  qryCalls.push(v)
  productReturn(v)
})

Array.from(filterOptions).forEach((opt, i) => {
  opt.addEventListener('change', (event) => handleCheckBox(event))
})

function createMulti(option) {
  let multi = ''

  option.filters.forEach((filter, i) => {
    // changed this from OR to AND
    i == 0 ? multi += `${filter}` : multi += `+OR+tag:${filter}`
  })
  return multi
}

function handleCheckBox(event) {
  document.getElementsByClassName('pagination')[0] ? document.getElementsByClassName('pagination')[0].classList.add('loadingCollection') : null
  document.getElementById('product-grid') ? document.getElementById('product-grid').innerHTML = '<h1>Loading...</h1>' : null

  // if one in the group is already checked, click() it again to uncheck it
  // later we take otherOptions and 
  const closestParent = event.target.closest('.filterCategoryOptions');
  const options = closestParent.querySelectorAll('.filterOption');
  const otherOptions = [];
  options.forEach((option) => {
    if (option.name != event.target.name) {
      otherOptions.push(option)
    }
  })

  let name = event.target.name
  let cat = event.target.getAttribute('data-cat')

  if (!event.target.checked && activeFilters.includes(name)) {
    activeFilters.forEach(filter => {
      if (name == filter) {
        activeFilters.splice(activeFilters.indexOf(name), 1)
        filterByCat[cat].splice(filterByCat[cat].indexOf(name), 1)
        let v = filterOptionChange()
        qryCalls.push(v)
        productReturn(v)
      }
    })
  }

  if (event.target.checked && !activeFilters.includes(name)) {
    // if it's the second one in a category, remove the first before adding to filterByCat
    otherOptions.forEach((option) => {
      if (option.checked == true) {
        option.checked = false;
        cat = option.getAttribute('data-cat');
        name = option.name;
        activeFilters.splice(activeFilters.indexOf(name), 1)
        filterByCat[cat].splice(filterByCat[cat].indexOf(name), 1)
      }
    })
    name = event.target.name
    cat = event.target.getAttribute('data-cat')
    // above was added
    activeFilters.push(name)
    filterByCat[cat].push(name)
    let v = filterOptionChange()
    qryCalls.push(v)
    productReturn(v)
  }

  if (!event.target.checked && activeFilters.length == 0) {
    let v = filterOptionChange()
    qryCalls.push(v)
    productReturn(v)
  }

  // console.log(qryCalls)
}

async function productReturn(str) {
  let products = await productFetch(str)
  if (await products) {
    if (str == qryCalls[qryCalls.length - 1]) {
      handleRes(await products)
      handleLinks(await products)
      qryCalls.splice(0)
    }
  }
}

function filterOptionChange(page, arrow) {
  const activeFilterList = document.getElementById('activeFilterList')
  let queryUrl
  let catStr
  let startStr
  let connectStr
  let vendorFilterOption = '/search?q=fromm+dog&options%5Bprefix%5D=last'
  let vendStr

  url.includes('vendor') ? vendStr = urlParams.get('q') : null

  if (vendStr) {
    catStr = `${vendStr}&`
  } else {
    urlParams.get('q') ? catStr = `/search?q=${urlParams.get('q')}+OR+tag:` : catStr = ''
  }

  filterByCat.forEach((item, i) => {
    let x
    if (item.length > 0) {
      filterByCat[i].forEach((filter, j) => {
        multiOpt.forEach(option => {
          if (option.name.includes(filter) && !option.name.includes(filter + '-')) {
            x = createMulti(option)
          }
        })
        // when you add a multiOption on the end, use an OR since those represent one filter
        if (typeof x !== 'undefined') { filter += `+OR+tag:${x}` }
        // if it's the first loop
        if (j === 0) {
          catStr += `tag:${filter}`
        } else {
          catStr += `AND+tag:${filter}`
        }
        filterByCat[i][j + 1] ? catStr += '+' : null
      })
    }
    if (filterByCat[i + 1] && filterByCat[i + 1].length > 0 && catStr !== '/search?type=product&q=') {
      let prev = false
      for (let z = i; z >= 0; z--) {
        if (filterByCat[z].length > 0) {
          prev = true
        }
      }

      if (prev == true) {
        catStr += '+AND+'
      }
    }
  })


  if (catStr) {
    if (activeSort.includes('none')) {
      // connectStr = 'q='
      startStr = `/search?type=product&q=`
    } else {
      connectStr = 'q='
      startStr = `/search?${activeSort}&type=product&q=`
      // startStr += activeSort
    }
  } else {
    if (activeSort != 'none') {
      startStr = `?${activeSort}&type=product`
    } else {
      startStr = '?'
    }
    // startStr = '?'
  }

  // if (activeSort.includes('none')) {
  //   connectStr = 'q='
  // } else {
  //   connectStr = 'q='
  //   // startStr += activeSort
  // }


  catStr ? startStr += `${catStr}` : null

  if (parseInt(page) && startStr.includes(`/collections/all`)) {
    startStr += `?page=${page}`
  } else if (parseInt(page) && !startStr.includes(`/collections/all`)) {
    startStr += `&page=${page}`
  } else if (arrow) {
    startStr = arrow
  }

  activeFilterList.innerHTML = ''
  activeFilters.forEach((filter, i) => {
    let li = document.createElement('LI')
    li.className = 'activeFilter'
    li.setAttribute('data-name', filter)
    li.innerHTML = `&#10005; ${filter}`
    li.addEventListener('click', (event) => activeFilterClick(event))
    activeFilterList.appendChild(li)
  })

  let label = document.getElementsByClassName('activeFilterLabel')[0]
  return startStr
}

async function productFetch(qryStr) {
  console.log(qryStr)
  return fetch(qryStr)
    .then((res) => { return res.text() })
}

function handleRes(string) {
  // console.log(string)
  const beforeBody = string.substring(string.indexOf(`<div class="product-grid-container`));

  const new_str = beforeBody.substring(0, beforeBody.indexOf(`</section>`));

  document.getElementById('productContent').innerHTML = new_str
  // if there are no results, do this:
  if (string.includes('Search: 0 results')) {
    document.getElementById('productContent').innerHTML = '<h2 style="margin: 30px 0 0 50px">No products found</h2>'
  }

  handleLinks()
  // this is from Jared - reruns the JS function that controls the 'Notify' button
  notifyBtns()
}


function activeFilterClick(event) {
  const name = event.target.getAttribute('data-name')

  Array.from(filterOptions).forEach((filter, i) => {
    const filterName = filter.getAttribute('name')
    name === filterName ? filter.click() : null
  })

}

// need to look at this to fix pagination issue 4/17/24 - Jared
function handleLinks() {
  let pages = document.getElementsByClassName('pagination__item')
  Array.from(pages).forEach((link, i) => {
    let arrowHref
    link.classList.contains('pagination__item-arrow') ? arrowHref = link.href : null
    link.addEventListener('click', (event) => {
      event.preventDefault()
      // filterOptionChange()
      let v = filterOptionChange(event.target.innerText, arrowHref)
      qryCalls.push(v)
      productReturn(v)
    })
  })
}

handleLinks()

mobileFilter.addEventListener('click', (event) => {
  filterBy.classList.toggle('showFilterBy')
})

function checkOption(x) {
  // console.log(x)
  let options = x.split(',')
  Array.from(document.getElementsByClassName('filterOption')).forEach(item => {
    options.forEach(option => {
      if (item.getAttribute('name') == option) {
        item.click()
      }
    })
  })

}

// search?q=cat+treats&options[prefix]=last

myParam ? checkOption(myParam) : null

window.onload = () => {
  let preloadFilter
  myParam ? preloadFilter = myParam.split(',') : preloadFilter = []
  Array.from(filterOptions).forEach((opt, i) => {
    if (opt.checked) {
      if (!preloadFilter.includes(opt.getAttribute('name'))) {
        opt.click()
        opt.click()
      }
    }
  })
}

